package de.oevbs.kunde.kundenportal2.services.account

import de.oevbs.kunde.kundenportal2.authentication.PortalSessionMiddleware
import de.oevbs.kunde.kundenportal2.model.services.account.AccountClientDefinition
import de.oevbs.sfa.communication.sfaServiceOrigin
import de.oevbs.sfa.communication.use
import io.ktor.client.*
import io.ktor.client.engine.js.*
import kotlinx.browser.window

class AccountClient : AccountClientDefinition(window.location.sfaServiceOrigin) {
    override val client: HttpClient = HttpClient(Js, config)

    init {
        use(PortalSessionMiddleware)
    }
}
